import { formatDate } from '../../../../../../../lib/date';

const replaceUnderScoreToSpace = (str) => {
  return str.replace(/[_]/g, ' ');
};

const convertStringToCapitalized = (str) => {
  return replaceUnderScoreToSpace(
    str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
  );
};

const ListItem = ({ icon, children }) => {
  return (
    <li className='flex items-start gap-2'>
      <span>{icon}</span>
      <span className='flex items-center gap-1 flex-wrap'>{children}</span>
    </li>
  );
};

const About = ({ challenge }) => {
  return (
    <div className='space-y-2'>
      <h2 className='uppercase font-bold text-sm text-white'>
        about the challenge
      </h2>
      <ul className='list-none rounded-xl px-4 py-3 bg-tertiary/20 space-y-2'>
        {challenge?.places.length > 0 && (
          <ListItem icon='🏠'>
            {challenge.places.map((place, i) => (
              <div
                key={i}
                className='text-white text-xs bg-tertiary/60 rounded-full px-2 py-1'
              >
                {convertStringToCapitalized(place.place)}
              </div>
            ))}
          </ListItem>
        )}
        {challenge?.category === 'WORKOUT' && (
          <ListItem icon='🏋🏼'>
            {challenge?.equipments.length > 0 ? (
              challenge?.equipments.map((equip, i) => (
                <div
                  key={i}
                  className='text-white text-xs bg-tertiary/60 rounded-full px-2 py-1'
                >
                  {convertStringToCapitalized(equip.equipment)}
                </div>
              ))
            ) : (
              <div className='text-white text-xs bg-tertiary/60 rounded-full px-2 py-1'>
                Equipment optional
              </div>
            )}
          </ListItem>
        )}
        {challenge?.category === 'WORKOUT' && challenge?.duration && (
          <ListItem icon='⏱️'>
            <div className='text-white text-xs bg-tertiary/60 rounded-full px-2 py-1'>
              {challenge.duration} mins / day
            </div>
          </ListItem>
        )}
        <ListItem icon='🗓️'>
          <div className='text-white text-xs bg-tertiary/60 rounded-full px-2 py-1'>
            {challenge?.days} days
          </div>
          {challenge?.live && (
            <span className='text-xs opacity-40 text-white'>
              ({formatDate(new Date(challenge?.startDate))} -{' '}
              {formatDate(new Date(challenge?.endDate))})
            </span>
          )}
        </ListItem>
      </ul>
    </div>
  );
};

export default About;
